<h2 class="title" [class.mobile]="deviceService.isMobile()">{{ 'school-main-tabs.classes' | translate }}</h2>

<div class="services-block" [class.mobile]="deviceService.isMobile()">
  <ng-template [ngIf]="services.items.length" [ngIfElse]="emptyContent">
    <div>
      <div class="services">
        <ng-template [ngIf]="services.loading">
          <div class="user-service-wrap">
            <loading-line height="76px" width="100%"></loading-line>
          </div>
        </ng-template>
        <div
          *ngFor="let userService of services.items; trackBy: trackUserServiceByFn"
          class="user-service-wrap">
          <app-user-service-card-2 displayMode="narrow2"
                                   [mode]="meIsOwnerSchool ? 'edit' : 'view'"
                                   [service]="userService"
                                   (removed)="onRemove($event)"
                                   (selected)="onSelect(userService)"
                                   (openUserServiceInModal)="onToggleUserServiceInModal($event)">
          </app-user-service-card-2>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #emptyContent>
    <div class="empty-block" *ngIf="meIsOwnerSchool">
      <app-empty [empty]="emptyClassesContent"></app-empty>
    </div>
  </ng-template>
</div>

<app-modal
  *ngIf="selectedService"
  [canClose]="false"
  (closed)="onCancelSchoolService()">
  <app-modal-body>
    <app-user-service-form-3 [userService]="selectedService" (changed)="onChangeUserService()"></app-user-service-form-3>
  </app-modal-body>
</app-modal>

<app-modal *ngIf="deviceService.isDesktop() && userServiceCardFullInModal"
           [canClose]="false"
           (closed)="onToggleUserServiceInModal()">
  <app-modal-body>
    <app-user-service-card-full [userService]="openedUserService"
                                [modal]="true"
                                (inViewportChange)="onIinViewportChange($event)">
    </app-user-service-card-full>
  </app-modal-body>
  <app-modal-ad>
    <ng-template [ngIf]="!surfaceBlockDisplay">
      <app-user-service-surface-block [userService]="openedUserService"></app-user-service-surface-block>
    </ng-template>
  </app-modal-ad>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && userServiceCardFullInModal"
                  [titleVisible]="true"
                  (closed)="onToggleUserServiceInModal()">
  <app-mobile-modal-body>
    <app-user-service-card-full [userService]="openedUserService" [modal]="true"></app-user-service-card-full>
  </app-mobile-modal-body>
</app-mobile-modal>
